import { fromJS } from 'immutable';
import { forEach, get, isEmpty, isNil, set, uniq } from 'lodash';
import { change } from 'redux-form/immutable';
import { put } from 'redux-saga/effects';
import uniqid from 'uniqid';
import { NDFL_FORM_ID } from '../../components/NDFL3/constants/forms';
import { calculateSourceTaxes, setIdsForArray } from './Ndfl3SagaService';
import deductionSelectorCodes from 'modules/Taps/constants/deductionSelectorCodes';

export const update3NDFLFormDraft = function* (response) {
  // Источники дохода
  get(response, 'payload.sheetA.sources', []).forEach((item) => {
    // Российская организация или организация, имеющая представительство на территории РФ
    item.sourceTypeSelector = item.sourceTypeSelector || 1;
    set(item, 'id', uniqid('incomeSource'));
    forEach(item.incomes, (income) => {
      set(income, 'id', uniqid('income'));
      setIdsForArray(get(income, 'agentDeductions'), 'agentDeductions');
    });
  });

  get(response, 'payload.sheetB.sources', []).forEach((item) => {
    set(item, 'id', uniqid('incomeSource'));
    setIdsForArray(get(item, 'moreDeductions'), 'moreDeductions');
  });

  if (isEmpty(get(response, 'payload.sheetE1.agentDeduction', {}))) {
    set(response, 'payload.sheetE1.agentDeduction', {
      stdDeductions: [],
    });

    set(response, 'payload.sheetE1.userDeduction', {
      stdDeductionSelf: {},
      stdDeductionChildren: { monthIncomes: [], listChildInfo: [], agentIncomeSelected: true },
    });
  }

  if (isEmpty(get(response, 'payload.sheetE2.charityLiveDeduction.childEducationAmounts', []))) {
    set(response, 'payload.sheetE2.charityLiveDeduction.childEducationAmounts', ['']);
  }

  get(response, 'payload.sheetD1.propertyObjects', []).forEach((item) => {
    if (isNil(item.fidRight) && !item.uid) {
      set(item, 'uid', uniqid('cpo_'));
    }
  });

  // always set model mode=1, shortScenarios with other modes should be updated
  set(response, 'mode', 1);

  //calculate income sources fields (set virtually calculated fields)
  set(
    response,
    'payload.sheetA.sources',
    calculateSourceTaxes(fromJS(response.payload.sheetA.sources)).toJS(),
  );

  yield put(change(NDFL_FORM_ID, `Ndfl3Package`, fromJS(response)));
};

/**
 * Set 3NDFL declaration deductions by deduction codes from 2NDFL list
 * @param ndfl2
 * @returns {IterableIterator<string>}
 */
export function* setDeductionsFrom2NDFL(ndfl2 = []) {
  const activeDeductionCodes = uniq(
    ndfl2.reduce(
      (arr, { deductionCodes = [] }) => (deductionCodes ? [...arr, ...deductionCodes] : arr),
      [],
    ),
  );
  const deductionSelector = {};

  Object.keys(deductionSelectorCodes).forEach((deductionKey) => {
    deductionSelector[deductionKey] =
      deductionSelectorCodes[deductionKey] &&
      deductionSelectorCodes[deductionKey].some((deductionCode) =>
        activeDeductionCodes.includes(deductionCode),
      );
  });

  yield put(
    change(NDFL_FORM_ID, `Ndfl3Package.payload.deductionSelector`, fromJS(deductionSelector)),
  );
}
